import React from 'react';
import ScoutingDatatable from "../../../scouting/components/datatable/ScoutingDatatable";
import {Link} from "react-router-dom";
import SVG from "react-inlinesvg";

import download_report_svg from '../../../../../../assets/svg/actions/icn-download-report.svg';
import chevron_rigth_svg from '../../../../../../assets/svg/actions/icn-chevron-rigth-24px.svg';

import '../../../../../../assets/sass/pages/profile-settings/components/purchase-history-datatable.scss';
import { Button } from 'react-bootstrap';


class PurchaseHistoryDataTable extends ScoutingDatatable {

    /**
     * Returns the table columns configurations.
     * @returns {{dataField: string, text: string, headerTitle: string, sort :boolean}[]} .
     * dataField: the dataField.
     * text: The column display name.
     * sort: Determine if column is sortable.
     * headerTitle:
     */
    columnsConfig = () => {
        return [
            {
                dataField: 'type',
                text: 'Account Type',
            }, {
                dataField: 'date',
                text: 'Date',
            }, {
                dataField: 'payment',
                text: 'Payment Type',
            }, {
                dataField: 'amount',
                text: 'Amount',
            }, {
                dataField: 'buttons_cell',
                text: '',
                headerFormatter: this.renderHeaderButton,
                renderer: this.renderButtonsScouting
            }
        ];
    };

    /**
     * Extra classes for datatable.
     * @type {{table: string}} The extra classes.
     */
    extraClasses = {
        table: 'scouting-datatable purchase-history-datatable',
    };
    
    openReceiptModal = (selectedRow) => {
        var { openReceiptModal } = this.props;
        if(openReceiptModal)
            openReceiptModal(selectedRow);
    }

    downloadReceiptModal = (selectedRow) => {
        var { downloadReceiptModal } = this.props;

        if(downloadReceiptModal)
            downloadReceiptModal(selectedRow);
    }

    downloadSelectedReceipt = () => {
        var { downloadSelectedReceipt } = this.props;

        if(downloadSelectedReceipt)
            downloadSelectedReceipt();
    }

    renderHeaderButton = () => {
        return (
            <Button 
                variant="link"
                className="p-0"
                disabled={!this.props.selectedRowsLength} 
                onClick={() => this.downloadSelectedReceipt()}
            ><SVG src={download_report_svg}/></Button>
        )
    }

    getSelectedRows = rows => {
        return rows.filter(row => row.selected);
    }

    renderButtonsScouting = (row) => {
        return (
            <div className="buttons-scouting--cell">
                <Link to={'#'} onClick={() => this.downloadReceiptModal(row)}><SVG src={download_report_svg}/></Link>
                <Link to={'#'} onClick={() => this.openReceiptModal(row)}><SVG src={chevron_rigth_svg}/></Link>
            </div>
        )
    }
}

export default PurchaseHistoryDataTable;